import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ProductoService } from 'src/app/abm/producto/producto.service';
import { Meses } from 'src/app/shared/enums/Meses';
import { Producto } from 'src/app/shared/models/abm/Producto';
import { ResolucionMensual } from 'src/app/shared/models/cierreTurno/ResolucionMensual';
import { ErrorModel } from 'src/app/shared/models/ErrorModel';
import { MessageService } from 'src/app/shell/message.service';
import { ReportesService } from '../../reportes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VisorInformeResolucionComponent } from './visor-informe-resolucion/visor-informe-resolucion.component';
import { ModalGenerarResolucionComponent } from './modal-generar-resolucion/modal-generar-resolucion.component';

@Component({
  selector: 'app-resolucion-mensual',
  templateUrl: './resolucion-mensual.component.html',
  styleUrls: ['./resolucion-mensual.component.scss']
})
export class ResolucionMensualComponent implements OnInit {

  fechaDesde: Date;
  fechaHasta: Date;

  meses=Meses;
  productos: Producto[];
  cargandoProductos: boolean;
  grabando: boolean;

  busqueda: UntypedFormGroup;
  obteniendoResolucion: boolean;
  generada: boolean = false;
  resolucionMensual: ResolucionMensual;

  constructor(
    private fb: UntypedFormBuilder,
    private spinner: NgxSpinnerService,
    private messageService:MessageService,
    private productoService:ProductoService,
    private reportesService: ReportesService,
    private activeModal: NgbModal
  ) { 
    let fecha = new Date();
    this.busqueda = this.fb.group({
      mesesFormControl: [null, Validators.required],
      anioFormControl: [fecha.getFullYear(), Validators.required],
      productoFormControl: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.obtenerProductos();
  }

  obtenerProductos() {
    this.cargandoProductos = true;
    this.productoService.obtenerProductos()
      .subscribe(resp=>{
        this.productos=resp.filter(p=>p.rubro.aerocombustible).filter(p=>p.activo); //|| p.rubro.combustible
        this.cargandoProductos = false;
      }, ()=>{
        this.cargandoProductos = false;
      })
  }

  obtenerResolucion() {
    this.generada = false;
    this.resolucionMensual = null;
    this.mostrarLoading();
    this.reportesService.obtenerResolucionMensual(this.productoFormControl.value, this.getFechaDesde(), this.getFechaHasta())
      .subscribe((res)=>{
        this.resolucionMensual=res;
        this.generada = this.resolucionMensual.generada;
        if (this.resolucionMensual.renglonesResolucion.length>0) {
          this.completarTotales();
        }
        this.ocultarLoading();
      }, (e:ErrorModel)=>{
        this.ocultarLoading();
        this.resolucionMensual = null;
        this.messageService.showErrorMessage(e.message);
      });    
  }

  keysMeses(): Array<string> {
    var keys = Object.keys(this.meses);
    keys = keys.slice(keys.length / 2);    
    return keys;
  }

  obtenerFechaInicioMes(mes:number) {
	  return new Date(this.anioFormControl.value, mes, 1);
  }

  obtenerFechaFinMes(mes:number) {
	  return new Date(this.anioFormControl.value, mes + 1, 0);
  }

  onChange(e:any) {
    console.log('target: '+e.target.selectedIndex); 
    this.fechaDesde = this.obtenerFechaInicioMes(e.target.selectedIndex-1);
    this.fechaHasta = this.obtenerFechaFinMes(e.target.selectedIndex-1);
    console.log('inicio: '+this.getFechaDesde());
    console.log('fin: '+this.getFechaHasta());
  }

  getFechaDesde(){
    return this.formatDate(this.fechaDesde.getFullYear(), this.fechaDesde.getMonth() + 1, this.fechaDesde.getDate(), 0, 0, 0);
  }

  getFechaHasta(){
    return this.formatDate(this.fechaHasta.getFullYear(), this.fechaHasta.getMonth() + 1, this.fechaHasta.getDate(), 23, 59, 59);
  }

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }

  mostrarLoading(){
    this.obteniendoResolucion = true;
    this.spinner.show('spinnerGrafico');
  }

  ocultarLoading(){
    this.obteniendoResolucion = false;
    this.spinner.hide('spinnerGrafico');
  }

  completarTotales() {
    for (const item of this.resolucionMensual.renglonesResolucion) {
      item.removido = item.existenciaInicial + item.entradas;
      item.supDef = item.existenciaFinal - (item.existenciaInicial + item.entradas - item.salidas);
      (item.removido!=0) ? item.porc = Math.abs(item.supDef)*100/item.removido : item.porc = 0;
      if (item.porc>item.toleranciaMensualOperativa) {
        item.resultado = 'FT';
        item.ft = ((item.porc / item.toleranciaMensualOperativa) - 1) * 100;
      } else { 
        item.resultado = 'DT'; 
        item.ft = 0;
      }      
    }
  }
  
  filtrarMovimientos() {
    this.obtenerResolucion();
  }

  generarResolucion() {
    /*
    this.reportesService.guardarResolucionMensual(this.resolucionMensual)
      .subscribe(r=>{
        this.messageService.showSuccessMessage('La resolución se generó con éxito.')
        this.grabando=false;
      }, (e:ErrorModel)=>{
        console.log(e);
        this.messageService.showErrorMessage("Hubo un error al generar la resolución");
        this.grabando=false;
      });*/
      let modalRef = this.activeModal.open(ModalGenerarResolucionComponent, { centered: true });
      modalRef.componentInstance.resolucion = this.resolucionMensual;
  }

  verResolucion() {
    let modalRef = this.activeModal.open(VisorInformeResolucionComponent, { centered: true, size: 'xl' });
    modalRef.componentInstance.pdfSrc = this.reportesService.base64ToArrayBuffer(this.resolucionMensual.pdf);
    modalRef.componentInstance.fileName = `Resolución_${this.resolucionMensual.codigoProducto}_${this.resolucionMensual.periodo}.pdf`
  }

  get mesesFormControl() {
    return this.busqueda.controls.mesesFormControl;
  }

  get anioFormControl() {
    return this.busqueda.controls.anioFormControl;
  }

  get productoFormControl() {
    return this.busqueda.controls.productoFormControl;
  }
}
